/* Wear-habit statuses drive the whole Smart Maintenance cadence. */

export const STATUS_OPTIONS = [
  { key: "Deadstock", label: "Deadstock (DS)", cleanDays: 120, rotateDays: null, note: "Never worn — inspect periodically, no rotation needed.", flightNote: "Rarely — inspect only" },
  { key: "VNDS", label: "VNDS", cleanDays: 90, rotateDays: 60, note: "Worn once or twice — clean and rotate sparingly.", flightNote: "Every 8–10 Flights" },
  { key: "Light Rotation", label: "Light Rotation", cleanDays: 45, rotateDays: 30, note: "Occasional wear — moderate cleaning cadence.", flightNote: "Every 5–7 Flights" },
  { key: "Heavy Rotation", label: "Heavy Rotation", cleanDays: 20, rotateDays: 14, note: "Regular wear — clean and rotate frequently.", flightNote: "Every 3–5 Flights" },
  { key: "Beater/Daily", label: "Beater / Daily", cleanDays: 10, rotateDays: 7, note: "Daily wear — highest maintenance cadence.", flightNote: "Every 1–2 Flights" },
];

export const STATUS_KEYS = STATUS_OPTIONS.map((s) => s.key);

export function statusMeta(key) {
  return STATUS_OPTIONS.find((s) => s.key === key) || STATUS_OPTIONS[2];
}
